import Vue from 'vue'
import { Button, Checkbox, Table, TableColumn, Loading, Message } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

locale.use(lang)
const components = [Button, Checkbox, Table, TableColumn]
components.forEach(item => {
  Vue.use(item)
})
Vue.use(Loading.directive)
Vue.prototype.$message = Message

